import { render, staticRenderFns } from "./subpage.vue?vue&type=template&id=3ea838a2&"
import script from "./subpage.vue?vue&type=script&lang=js&"
export * from "./subpage.vue?vue&type=script&lang=js&"
import style0 from "./subpage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports